import { render, staticRenderFns } from "./sub_title_a.vue?vue&type=template&id=ab579d7c&scoped=true&"
import script from "./sub_title_a.vue?vue&type=script&lang=js&"
export * from "./sub_title_a.vue?vue&type=script&lang=js&"
import style0 from "./sub_title_a.vue?vue&type=style&index=0&id=ab579d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab579d7c",
  null
  
)

export default component.exports